import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { erpApi } from '../../api/erp'
import { fmtFecha } from '../../utils/fecha'
import { mensajeError, fmtImporte, TIPO_LABEL } from './_helpers'

/**
 * Impresión de un comprobante de la 900 (Martin, 25 ago): "sin logos ni
 * insignias ni diseño — solo datos de cliente, dirección y detalle de
 * productos y valores". Es un documento de GESTIÓN (ADR-0010 §8): sin CAE,
 * sin letra, sin punto de venta de ARCA.
 *
 * Los datos del cliente (documento, domicilio COMPLETO) los trae el ERP en
 * `tercero` (docs/lgr-pedidos-al-erp.md). Si no vienen, no se imprime.
 */
const fecha = (s) => (s && String(s).includes('/')) ? s : fmtFecha(s)

export default function Emp900ImprimirPage() {
  const { id } = useParams()
  const [data, setData] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    erpApi.comprobante(id).then(({ data }) => setData(data)).catch(e => setError(mensajeError(e)))
  }, [id])

  if (error) return <p style={css.aviso}>{error}</p>
  if (!data) return <p style={css.aviso}>Cargando…</p>
  const c = data.comprobante
  const t = data.tercero
  const d = t?.domicilio
  if (!t || !d) return <p style={css.aviso}>El ERP no devolvió los datos del cliente (documento y domicilio): este comprobante no se imprime sin ellos.</p>

  const domicilio = [
    [d.calle, d.numero].filter(Boolean).join(' '),
    d.piso_depto,
    [d.localidad, d.provincia].filter(Boolean).join(', '),
    d.codigo_postal ? `CP ${d.codigo_postal}` : null,
  ].filter(Boolean).join(' · ')
  const obs = String(c.observaciones || '').split(/(?=\[AVISO\])/).filter(s => !s.startsWith('[AVISO]')).join('').trim()

  return (
    <div style={css.hoja}>
      <button style={css.btn} className="no-print" onClick={() => window.print()}>Imprimir</button>
      <style>{'@media print { .no-print { display: none } body { background: #fff } }'}</style>

      <table style={css.cab}><tbody>
        <tr><td style={css.k}>Comprobante</td><td style={css.v}>{(TIPO_LABEL[c.tipo] || c.tipo).toUpperCase()} {c.numero}{c.estado === 'anulado' ? ' — ANULADO' : ''}</td></tr>
        <tr><td style={css.k}>Fecha</td><td style={css.v}>{fecha(c.fecha)}</td></tr>
        <tr><td style={css.k}>Cliente</td><td style={css.v}>{t.razon_social}{t.codigo ? ` (${t.codigo})` : ''}</td></tr>
        <tr><td style={css.k}>{t.tipo_documento || 'Documento'}</td><td style={css.v}>{t.documento}</td></tr>
        {t.condicion_iva && <tr><td style={css.k}>Condición IVA</td><td style={css.v}>{t.condicion_iva}</td></tr>}
        <tr><td style={css.k}>Domicilio</td><td style={css.v}>{domicilio}</td></tr>
      </tbody></table>

      {(data.items || []).length > 0 && (
        <table style={css.tabla}>
          <thead><tr>
            <th style={css.th}>Código</th><th style={css.th}>Descripción</th>
            <th style={css.thN}>Cantidad</th><th style={css.thN}>Precio</th><th style={css.thN}>Total</th>
          </tr></thead>
          <tbody>
            {data.items.map((i, k) => (
              <tr key={k}>
                <td style={css.td}>{i.sku}</td><td style={css.td}>{i.descripcion}</td>
                <td style={css.tdN}>{Number(i.cantidad)}</td><td style={css.tdN}>{fmtImporte(i.precio_unitario)}</td><td style={css.tdN}>{fmtImporte(i.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p style={css.total}>TOTAL {fmtImporte(c.total)}</p>
      {obs && <p style={css.obs}>{obs}</p>}
    </div>
  )
}

// Sin tokens a propósito: es un papel blanco y negro, no una pantalla de LGR.
const css = {
  hoja: { maxWidth: 720, margin: '24px auto', padding: 24, fontFamily: 'Arial, Helvetica, sans-serif', fontSize: 13, color: '#000', background: '#fff' },
  btn: { marginBottom: 16, padding: '6px 14px', fontSize: 13, cursor: 'pointer' },
  cab: { borderCollapse: 'collapse', marginBottom: 20 },
  k: { padding: '3px 12px 3px 0', fontWeight: 700, verticalAlign: 'top', whiteSpace: 'nowrap' },
  v: { padding: '3px 0', verticalAlign: 'top' },
  tabla: { width: '100%', borderCollapse: 'collapse', marginBottom: 12 },
  th: { textAlign: 'left', borderBottom: '1px solid #000', padding: '4px 6px' },
  thN: { textAlign: 'right', borderBottom: '1px solid #000', padding: '4px 6px' },
  td: { padding: '4px 6px', borderBottom: '1px solid #ccc', verticalAlign: 'top' },
  tdN: { padding: '4px 6px', borderBottom: '1px solid #ccc', textAlign: 'right', whiteSpace: 'nowrap', verticalAlign: 'top' },
  total: { textAlign: 'right', fontWeight: 700, fontSize: 15, margin: '8px 6px 16px' },
  obs: { whiteSpace: 'pre-wrap', margin: 0 },
  aviso: { fontFamily: 'Arial, sans-serif', padding: 24 },
}
